export enum ImportWarningStatus {
  Created,
  EntitiesCountExceeded,
  EntityNameLengthExceeded,
  LocationCategoryCreated,
  LocationCreated,
  LocationNotCreated,
  NotCreated,
  UndeclaredActivity,
}
